import {
    useCallback,
} from 'react'
import {
    useNavigate,
} from 'react-router-dom'
import {
    ActionBulkComponentFunction,
} from 'app/shared-components/SkyNetDomain/SkyNetDomain.types'

type Props = {
    component: ActionBulkComponentFunction,
}

const BulkActionWrapper = ({
    component: Component,
}: Readonly<Props>) => {
    const navigate = useNavigate()

    const handleClose = useCallback(() => {
        navigate(-1)
    }, [navigate])

    return (
        <Component onClose={handleClose} />
    )
}

export default BulkActionWrapper
